export default __webpack_public_path__ + "assets/33451a164cf523027c883c3db5e62c9f.png";